module.exports = __webpack_public_path__ + "img/11.41363489.png";